import React from 'react';

class Search extends React.Component {

  constructor(props) {
    super(props);
    this.state ={
      name: ''
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleChange(e) {
    this.setState({name: e.target.value})
  }

  handleSubmit(e) {
      e.preventDefault();
      this.props.search(this.state.name);
      this.setState({name: ''})
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="input-field col s12">
                    <i className="material-icons prefix">search</i>
                    <input id="icon_prefix" type="text" className="validate" value={this.state.name} onChange={this.handleChange}/>
                    <label htmlFor="icon_prefix">Github login Name</label>
            </div>
        </div>
      </form>
    )
  }


}

export default Search;
